import { ArrowRight, Briefcase, FolderKanban, ShieldCheck, Video } from 'lucide-react';

type WelcomeStageProps = {
  firstName?: string;
  onContinue: () => void;
};

export default function WelcomeStage({ firstName, onContinue }: WelcomeStageProps) {
  const greeting = firstName?.trim() ? `, ${firstName.trim()}` : '';

  return (
    <div className="ssr-welcome">
      <div className="ssr-welcome__card">
        <p className="ssr-welcome__eyebrow">Welcome to SkipScreen</p>
        <h1 className="ssr-welcome__title">
          Hi{greeting} — let&apos;s build a profile recruiters can trust
        </h1>
        <p className="ssr-welcome__lede">
          SkipScreen helps you skip repetitive screening calls. Recruiters review your profile and
          video answers first, then invite you to interview when there&apos;s a real fit.
        </p>

        <ul className="ssr-welcome__list">
          <li className="ssr-welcome__item ssr-welcome__item--priority">
            <span className="ssr-welcome__icon" aria-hidden>
              <Video size={20} />
            </span>
            <div>
              <p className="ssr-welcome__item-title">
                Screening prompts
                <span className="ssr-welcome__badge">Most important</span>
              </p>
              <p className="ssr-welcome__item-body">
                Short video answers that show how you think and work. This is the #1 thing
                recruiters use to evaluate fit beyond your resume — and the strongest signal on your
                profile.
              </p>
            </div>
          </li>
          <li className="ssr-welcome__item">
            <span className="ssr-welcome__icon" aria-hidden>
              <Briefcase size={20} />
            </span>
            <div>
              <p className="ssr-welcome__item-title">Resume-powered draft</p>
              <p className="ssr-welcome__item-body">
                Upload your resume and we&apos;ll draft your experience, skills, and role so you can
                polish instead of starting from scratch.
              </p>
            </div>
          </li>
          <li className="ssr-welcome__item">
            <span className="ssr-welcome__icon" aria-hidden>
              <FolderKanban size={20} />
            </span>
            <div>
              <p className="ssr-welcome__item-title">Portfolio extras</p>
              <p className="ssr-welcome__item-body">
                Projects, certifications, and accomplishments help — but video screening answers
                carry the most weight.
              </p>
            </div>
          </li>
        </ul>

        <div className="ssr-welcome__note">
          <ShieldCheck size={16} aria-hidden />
          <p>
            Your profile stays private until you&apos;re ready. You can edit everything later —
            start with your resume, then add screening prompts on the review step.
          </p>
        </div>

        <button type="button" className="ssr-welcome__cta" onClick={onContinue}>
          Get started
          <ArrowRight size={16} aria-hidden />
        </button>
      </div>
    </div>
  );
}
